import { rem } from "polished";
import styled from "styled-components";

import { CARD_VERTICAL_GAP } from "./constants";

export const BoothsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: -${rem(CARD_VERTICAL_GAP)};
`;
